import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=c23c072e&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=js&"
export * from "./Research.vue?vue&type=script&lang=js&"
import style0 from "./Research.vue?vue&type=style&index=0&id=c23c072e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23c072e",
  null
  
)

export default component.exports